export const SUB_CATEGORY_CREATE_REQUEST = "SUB_CATEGORY_CREATE_REQUEST"
export const SUB_CATEGORY_DELETE_REQUEST = "SUB_CATEGORY_DELETE_REQUEST"
export const SUB_CATEGORY_UPDATE_REQUEST = "SUB_CATEGORY_UPDATE_REQUEST"
export const SUB_CATEGORY_DETAILS_REQUEST = "SUB_CATEGORY_DETAILS_REQUEST"
export const GET_SUB_CATEGORIES_REQUEST = "GET_SUB_CATEGORIES_REQUEST"


